import api from '@/utils/interceptor'
// 标准规范文件查询
export const queryFiles = params => {
  return api.post('/access/ui/GTCPSP-FRONT/GTCPSPCMSARTICLESERVICE004', params)
}
